module.exports = __webpack_public_path__ + "img/虎纽印章.9064aceb.gif";